import { SidePanelTabName } from '@mobile-mapping/providers';
import { t } from '@trimble/i18n';
import { VerticalTab } from '@trimble/ui-components/solidjs';
import { LayersTab } from './LayersTab';

export function createLayersSidePanelTab(): VerticalTab<SidePanelTabName> {
  return {
    name: SidePanelTabName.Layers,
    tooltip: {
      text: t('mobileMapping.layers.title'),
      position: 'right',
    },
    icon: 'layer',
    iconClass: 'modus-icons',
    content: () => <LayersTab />,
  };
}
